const PLACEHOLDER = '---';

export { PLACEHOLDER };
//# sourceMappingURL=constants.js.map
